const flagSelectService = (() => {
    return {
        sortValues : (values, isFooterDropDown) => {
            values.sort(function (a, b) {
                return (!isFooterDropDown ? sortingFn(a.country.name, b.country.name) : sortingFn(a['value'], b['value']))
            });
            return values;
        },
        initiateFlagSelect : (countryListRefactored, flagSelectDropdown, flagIndex, topEntries, selectedCountry, isFooterDropDown = false, countries, optimusCountryList) => {
            if (Object.keys(countryListRefactored).length > 0) {
                new FlagSelect({
                    parent: flagSelectDropdown,
                    countryList: countryListRefactored,
                    selectedCountry,
                    indexOfFlagSelect: flagIndex,
                    topEntriesLength: topEntries.length,
                    isFooterDropDown,
                    countries,
                    optimusCountryList
                }).init()
            } else {
                flagSelectDropdown.classList.add('d-none')
            }
        },
        getCountriesConfig : (countries, countryList, dataSelected,
            topCountryList, topEntries, optimusCountryList) => {
            let selectedCountry = {},
                countryListRefactored = [];
            const exceptionList = getExceptionList()
            for (let index in topCountryList) {
                if (index !== 'listPath' && topCountryList[index]) {
                    const listVal = topCountryList[index];
                    const value = Object.values(listVal)[0]
                    countryListRefactored.push({
                        'value': value,
                        'code': Object.keys(listVal)[0]
                    });
                    topEntries.push(value);
                }
            }
            const dataSelectedLowerCase = dataSelected.toUpperCase();
            countries.forEach((country) => {
                const isoCode = country.country.isoCode;
                const countryListValue = countryList[isoCode];
                let countryCodeLowerCase = isoCode.toUpperCase();
                if (dataSelectedLowerCase === countryCodeLowerCase)
                    selectedCountry = {
                        'code': countryCodeLowerCase,
                        'value': optimusCountryList && optimusCountryList[countryCodeLowerCase] ? countryCodeLowerCase :  countryListValue
                    }
                if (
                  countryListValue &&
                  !exceptionList.includes(countryCodeLowerCase) &&
                  topEntries.indexOf(countryListValue) === -1
                ) {
                  countryListRefactored.push({
                    code: isoCode,
                    value: countryListValue,
                  });
                }
            })
            return {
                countryListRefactored,
                topEntries,
                selectedCountry
            };
        }
    }
})()